module.exports = __webpack_public_path__ + "assets/img/img-hotel-11.50e745c2.jpg";